import React from "react";
import useFetch from "../hooks/useFetch";

// Дефолтный контент из макета — используется, пока в CMS не заполнен тип "Экспертиза".
// Каждая надпись редактируется в Strapi (single-type expertise + карточки expertise-card).
const DEFAULT_TITLE_START = "В чем";
const DEFAULT_TITLE_ACCENT = "мы сильны";
const DEFAULT_CARDS = [
  {
    id: "d1",
    Title: "Продуктовая логика",
    Text: "Проектируем сценарии так, чтобы продукт решал задачу, а не просто выглядел готовым",
  },
  {
    id: "d2",
    Title: "Сложные B2B/B2G-контуры",
    Text: "Запускаем там, где много стейкхолдеров (бизнес, безопасность, юристы, финансы) и жёсткая регуляторика",
  },
  {
    id: "d3",
    Title: "ИИ, данные и автоматизация",
    Text: "Собираем системы, где ИИ и данные превращают хаос в управляемые процессы.",
  },
  {
    id: "d4",
    Title: "Документация и масштабируемость",
    Text: "Передаём продукт так, чтобы после запуска его можно было развивать и масштабировать без вендор-лока",
  },
];

export default function ExpertiseSection() {
  const expertiseFetch = useFetch(`${window.$host}/api/expertise?populate=*`);

  // Пока фетч не settled — не рендерим ничего: дефолт и реальные карточки
  // из CMS идут в разном порядке (разные id => разные React key), и рендер
  // дефолта, пока идёт запрос, даёт видимую пересортировку карточек, когда
  // приходят настоящие данные.
  if (expertiseFetch.loading) return null;

  const cms =
    !expertiseFetch.error && expertiseFetch.data
      ? expertiseFetch.data.data
      : null;

  const titleStart = cms?.TitleStart || DEFAULT_TITLE_START;
  const titleAccent = cms?.TitleAccent ?? DEFAULT_TITLE_ACCENT;
  const cards = cms?.Cards && cms.Cards.length ? cms.Cards : DEFAULT_CARDS;

  return (
    <section className="expertise" id="expertise">
      <div className="expertise__bg" aria-hidden="true"></div>
      <div className="container">
        <div className="h-100 expertise__box">
          <h2 className="title-3 expertise__title">
            {titleStart}{" "}
            <span className="expertise__title-accent">{titleAccent}</span>
          </h2>
          <ul className="expertise__grid">
            {cards.map((card) => (
              <li key={card.id} className="exp-card">
                <h3 className="exp-card__title">{card.Title}</h3>
                <p className="exp-card__text">{card.Text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
